/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { formatDate } from '@fullcalendar/core'
import React, { useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { ROUTE_TYPE } from '../../Configuration'
import { formatUTCDateToLocal } from '../../assets/ts/date-and-time/date-and-time'
import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'
import Buttons from '../../components/buttons/buttons'
import Helpdesk from '../../components/helpdesk/helpdesk'
import LoginUser from '../../components/loginuser/loginuser'
import Notifications from '../../components/notifications/notifications'
import { UserContext } from '../../store/user-context-provider'
import './header.css'

const Header = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname } = location
  const splitLocation = pathname.split('/')
  const { me } = useContext(UserContext)
  const redirectToProfile = () => {
    navigate(`${ROUTE_TYPE}profile`)
  }
  return (
    <div className='header shadow5'>
      <div className='container d-flex py-2 align-items-center'>
        <div className='d-flex ms-auto align-items-center justify-content-end p-relative w-100 flex-wrap'>
          {me?.lastLogin && (
            <div
              aria-live='polite'
              className='title-color47 font-12 poppins-medium ms-5 me-2'
              tabIndex={0}
            >
              {' '}
              <span className='icon-lastlogin font-15 pe-2'></span>Last Successful Login:{' '}
              {defaultToEmptyString(formatUTCDateToLocal(me?.lastLogin))}{' '}
            </div>
          )}
          <Notifications />
          <Buttons
            aria-label='Profile'
            className={
              splitLocation[1] === 'profile'
                ? 'btn-border btn-md font-0 font-lg-13 poppins-medium btn-border-radius3 p-relative text-uppercase active btn-hover px-3'
                : 'btn-border btn-md font-0 font-lg-13 poppins-medium btn-border-radius3 p-relative text-uppercase px-3'
            }
            icon='icon-user color-primary font-13 me-md-1 bold'
            label='Profile'
            onClick={(e: any) => redirectToProfile()}
          />

          <Helpdesk />

          {me && <LoginUser me={me} />}
        </div>
      </div>
    </div>
  )
}
export default Header
